{
  "generatedAt": "2026-11-03T13:39:35.622Z",
  "commodities": [
    {
      "symbol": "AdvancedCatalysers",
      "name": "Advanced Catalysers"
    },
    {
      "symbol": "AdvancedMedicines",
      "name": "Advanced Medicines"
    },
    {
      "symbol": "AgriculturalMedicines",
      "name": "Agri-Medicines"
    },
    {
      "symbol": "AgronomicTreatment",
      "name": "Agronomic Treatment"
    },
    {
      "symbol": "AiRelics",
      "name": "AI Relics"
    },
    {
      "symbol": "Alexandrite",
      "name": "Alexandrite"
    },
    {
      "symbol": "Algae",
      "name": "Algae"
    },
    {
      "symbol": "Aluminium",
      "name": "Aluminium"
    },
    {
      "symbol": "USSCargoAncientArtefact",
      "name": "Ancient Artefact"
    },
    {
      "symbol": "AncientKey",
      "name": "Ancient Key"
    },
    {
      "symbol": "Animalmeat",
      "name": "Animal Meat"
    },
    {
      "symbol": "AnimalMonitors",
      "name": "Animal Monitors"
    },
    {
      "symbol": "P_ParticulateSample",
      "name": "Anomaly Particles"
    },
    {
      "symbol": "AntimatterContainmentUnit",
      "name": "Antimatter Containment Unit"
    },
    {
      "symbol": "AntiqueJewellery",
      "name": "Antique Jewellery"
    },
    {
      "symbol": "Antiquities",
      "name": "Antiquities"
    },
    {
      "symbol": "AquaponicSystems",
      "name": "Aquaponic Systems"
    },
    {
      "symbol": "ArticulationMotors",
      "name": "Articulation Motors"
    },
    {
      "symbol": "AssaultPlans",
      "name": "Assault Plans"
    },
    {
      "symbol": "AtmosphericExtractors",
      "name": "Atmospheric Processors"
    },
    {
      "symbol": "AutoFabricators",
      "name": "Auto-Fabricators"
    },
    {
      "symbol": "BasicMedicines",
      "name": "Basic Medicines"
    },
    {
      "symbol": "Bastnasite",
      "name": "Bastnasite"
    },
    {
      "symbol": "BattleWeapons",
      "name": "Battle Weapons"
    },
    {
      "symbol": "Bauxite",
      "name": "Bauxite"
    },
    {
      "symbol": "Beer",
      "name": "Beer"
    },
    {
      "symbol": "Benitoite",
      "name": "Benitoite"
    },
    {
      "symbol": "Bertrandite",
      "name": "Bertrandite"
    },
    {
      "symbol": "Beryllium",
      "name": "Beryllium"
    },
    {
      "symbol": "BioReducingLichen",
      "name": "Bioreducing Lichen"
    },
    {
      "symbol": "Biowaste",
      "name": "Biowaste"
    },
    {
      "symbol": "Bismuth",
      "name": "Bismuth"
    },
    {
      "symbol": "USSCargoBlackBox",
      "name": "Black Box"
    },
    {
      "symbol": "ThargoidBoneFragments",
      "name": "Bone Fragments"
    },
    {
      "symbol": "BootlegLiquor",
      "name": "Bootleg Liquor"
    },
    {
      "symbol": "Bromellite",
      "name": "Bromellite"
    },
    {
      "symbol": "BuildingFabricators",
      "name": "Building Fabricators"
    },
    {
      "symbol": "ThargoidGeneratorTissueSample",
      "name": "Caustic Tissue Sample"
    },
    {
      "symbol": "CeramicComposites",
      "name": "Ceramic Composites"
    },
    {
      "symbol": "ChemicalWaste",
      "name": "Chemical Waste"
    },
    {
      "symbol": "Clothing",
      "name": "Clothing"
    },
    {
      "symbol": "CMMComposite",
      "name": "CMM Composite"
    },
    {
      "symbol": "Cobalt",
      "name": "Cobalt"
    },
    {
      "symbol": "Coffee",
      "name": "Coffee"
    },
    {
      "symbol": "Coltan",
      "name": "Coltan"
    },
    {
      "symbol": "CombatStabilisers",
      "name": "Combat Stabilisers"
    },
    {
      "symbol": "ComercialSamples",
      "name": "Commercial Samples"
    },
    {
      "symbol": "ComputerComponents",
      "name": "Computer Components"
    },
    {
      "symbol": "ConductiveFabrics",
      "name": "Conductive Fabrics"
    },
    {
      "symbol": "ConsumerTechnology",
      "name": "Consumer Technology"
    },
    {
      "symbol": "Copper",
      "name": "Copper"
    },
    {
      "symbol": "CoralSap",
      "name": "Coral Sap"
    },
    {
      "symbol": "CropHarvesters",
      "name": "Crop Harvesters"
    },
    {
      "symbol": "Cryolite",
      "name": "Cryolite"
    },
    {
      "symbol": "CuratedCommodity",
      "name": "Curated Commodity Package"
    },
    {
      "symbol": "ThargoidCystSpecimen",
      "name": "Cyst Specimen"
    },
    {
      "symbol": "DamagedEscapePod",
      "name": "Damaged Escape Pod"
    },
    {
      "symbol": "DataCore",
      "name": "Data Core"
    },
    {
      "symbol": "Deuterium",
      "name": "Deuterium"
    },
    {
      "symbol": "Diamond",
      "name": "Diamond"
    },
    {
      "symbol": "DiplomaticBag",
      "name": "Diplomatic Bag"
    },
    {
      "symbol": "DomesticAppliances",
      "name": "Domestic Appliances"
    },
    {
      "symbol": "EarthRelics",
      "name": "Earth Relics"
    },
    {
      "symbol": "EmergencyPowerCells",
      "name": "Emergency Power Cells"
    },
    {
      "symbol": "EncryptedCorrespondence",
      "name": "Encrypted Correspondence"
    },
    {
      "symbol": "EncriptedDataStorage",
      "name": "Encrypted Data Storage"
    },
    {
      "symbol": "PowerGridAssembly",
      "name": "Energy Grid Assembly"
    },
    {
      "symbol": "EvacuationShelter",
      "name": "Evacuation Shelter"
    },
    {
      "symbol": "ExhaustManifold",
      "name": "Exhaust Manifold"
    },
    {
      "symbol": "USSCargoExperimentalChemicals",
      "name": "Experimental Chemicals"
    },
    {
      "symbol": "Explosives",
      "name": "Explosives"
    },
    {
      "symbol": "Fish",
      "name": "Fish"
    },
    {
      "symbol": "FoodCartridges",
      "name": "Food Cartridges"
    },
    {
      "symbol": "FossilRemnants",
      "name": "Fossil Remnants"
    },
    {
      "symbol": "FruitAndVegetables",
      "name": "Fruit and Vegetables"
    },
    {
      "symbol": "Gallite",
      "name": "Gallite"
    },
    {
      "symbol": "Gallium",
      "name": "Gallium"
    },
    {
      "symbol": "GeneBank",
      "name": "Gene Bank"
    },
    {
      "symbol": "GeologicalEquipment",
      "name": "Geological Equipment"
    },
    {
      "symbol": "GeologicalSamples",
      "name": "Geological Samples"
    },
    {
      "symbol": "Gold",
      "name": "Gold"
    },
    {
      "symbol": "Goslarite",
      "name": "Goslarite"
    },
    {
      "symbol": "Grain",
      "name": "Grain"
    },
    {
      "symbol": "Grandidierite",
      "name": "Grandidierite"
    },
    {
      "symbol": "AncientCasket",
      "name": "Guardian Casket"
    },
    {
      "symbol": "AncientOrb",
      "name": "Guardian Orb"
    },
    {
      "symbol": "AncientRelic",
      "name": "Guardian Relic"
    },
    {
      "symbol": "AncientTablet",
      "name": "Guardian Tablet"
    },
    {
      "symbol": "AncientTotem",
      "name": "Guardian Totem"
    },
    {
      "symbol": "AncientUrn",
      "name": "Guardian Urn"
    },
    {
      "symbol": "HazardousEnvironmentSuits",
      "name": "H.E. Suits"
    },
    {
      "symbol": "Haematite",
      "name": "Haematite"
    },
    {
      "symbol": "Hafnium178",
      "name": "Hafnium 178"
    },
    {
      "symbol": "DiagnosticSensor",
      "name": "Hardware Diagnostic Sensor"
    },
    {
      "symbol": "HeatsinkInterlink",
      "name": "Heatsink Interlink"
    },
    {
      "symbol": "Helium",
      "name": "Helium"
    },
    {
      "symbol": "Helium3",
      "name": "Helium-3"
    },
    {
      "symbol": "HNShockMount",
      "name": "HN Shock Mount"
    },
    {
      "symbol": "Hostage",
      "name": "Hostages"
    },
    {
      "symbol": "HydrogenFuel",
      "name": "Hydrogen Fuel"
    },
    {
      "symbol": "HydrogenPeroxide",
      "name": "Hydrogen Peroxide"
    },
    {
      "symbol": "ImperialSlaves",
      "name": "Imperial Slaves"
    },
    {
      "symbol": "UnknownMineral",
      "name": "Impure Spire Mineral"
    },
    {
      "symbol": "Indite",
      "name": "Indite"
    },
    {
      "symbol": "Indium",
      "name": "Indium"
    },
    {
      "symbol": "InsulatingMembrane",
      "name": "Insulating Membrane"
    },
    {
      "symbol": "IonDistributor",
      "name": "Ion Distributor"
    },
    {
      "symbol": "Iridium",
      "name": "Iridium"
    },
    {
      "symbol": "Jadeite",
      "name": "Jadeite"
    },
    {
      "symbol": "TerrainEnrichmentSystems",
      "name": "Land Enrichment Systems"
    },
    {
      "symbol": "Landmines",
      "name": "Landmines"
    },
    {
      "symbol": "Lanthanum",
      "name": "Lanthanum"
    },
    {
      "symbol": "LargeExplorationDataCash",
      "name": "Large Survey Data Cache"
    },
    {
      "symbol": "Leather",
      "name": "Leather"
    },
    {
      "symbol": "Lepidolite",
      "name": "Lepidolite"
    },
    {
      "symbol": "Drones",
      "name": "Limpets"
    },
    {
      "symbol": "LiquidOxygen",
      "name": "Liquid oxygen"
    },
    {
      "symbol": "Liquor",
      "name": "Liquor"
    },
    {
      "symbol": "Lithium",
      "name": "Lithium"
    },
    {
      "symbol": "LithiumHydroxide",
      "name": "Lithium Hydroxide"
    },
    {
      "symbol": "LowTemperatureDiamond",
      "name": "Low Temperature Diamonds"
    },
    {
      "symbol": "Magnesite",
      "name": "Magnesite"
    },
    {
      "symbol": "MagneticEmitterCoil",
      "name": "Magnetic Emitter Coil"
    },
    {
      "symbol": "MarineSupplies",
      "name": "Marine Equipment"
    },
    {
      "symbol": "MedicalDiagnosticEquipment",
      "name": "Medical Diagnostic Equipment"
    },
    {
      "symbol": "MetaAlloys",
      "name": "Meta-Alloys"
    },
    {
      "symbol": "MethaneClathrate",
      "name": "Methane Clathrate"
    },
    {
      "symbol": "MethanolMonohydrateCrystals",
      "name": "Methanol Monohydrate Crystals"
    },
    {
      "symbol": "MicroControllers",
      "name": "Micro Controllers"
    },
    {
      "symbol": "CoolingHoses",
      "name": "Micro-weave Cooling Hoses"
    },
    {
      "symbol": "HeliostaticFurnaces",
      "name": "Microbial Furnaces"
    },
    {
      "symbol": "MilitaryGradeFabrics",
      "name": "Military Grade Fabrics"
    },
    {
      "symbol": "MilitaryIntelligence",
      "name": "Military Intelligence"
    },
    {
      "symbol": "USSCargoMilitaryPlans",
      "name": "Military Plans"
    },
    {
      "symbol": "MineralExtractors",
      "name": "Mineral Extractors"
    },
    {
      "symbol": "MineralOil",
      "name": "Mineral Oil"
    },
    {
      "symbol": "ModularTerminals",
      "name": "Modular Terminals"
    },
    {
      "symbol": "Moissanite",
      "name": "Moissanite"
    },
    {
      "symbol": "M_TissueSample_Nerves",
      "name": "Mollusc Brain Tissue"
    },
    {
      "symbol": "M_TissueSample_Fluid",
      "name": "Mollusc Fluid"
    },
    {
      "symbol": "M3_TissueSample_Membrane",
      "name": "Mollusc Membrane"
    },
    {
      "symbol": "M3_TissueSample_Mycelium",
      "name": "Mollusc Mycelium"
    },
    {
      "symbol": "M_TissueSample_Soft",
      "name": "Mollusc Soft Tissue"
    },
    {
      "symbol": "M3_TissueSample_Spores",
      "name": "Mollusc Spores"
    },
    {
      "symbol": "Monazite",
      "name": "Monazite"
    },
    {
      "symbol": "MuTomImager",
      "name": "Muon Imager"
    },
    {
      "symbol": "Musgravite",
      "name": "Musgravite"
    },
    {
      "symbol": "MysteriousIdol",
      "name": "Mysterious Idol"
    },
    {
      "symbol": "Nanobreakers",
      "name": "Nanobreakers"
    },
    {
      "symbol": "BasicNarcotics",
      "name": "Narcotics"
    },
    {
      "symbol": "NaturalFabrics",
      "name": "Natural Fabrics"
    },
    {
      "symbol": "NeofabricInsulation",
      "name": "Neofabric Insulation"
    },
    {
      "symbol": "NerveAgents",
      "name": "Nerve Agents"
    },
    {
      "symbol": "NonLethalWeapons",
      "name": "Non-Lethal Weapons"
    },
    {
      "symbol": "OccupiedCryoPod",
      "name": "Occupied Escape Pod"
    },
    {
      "symbol": "Olivine",
      "name": "Olivine"
    },
    {
      "symbol": "OnionHeadC",
      "name": "Onionhead Gamma Strain"
    },
    {
      "symbol": "ThargoidOrganSample",
      "name": "Organ Sample"
    },
    {
      "symbol": "Osmium",
      "name": "Osmium"
    },
    {
      "symbol": "Painite",
      "name": "Painite"
    },
    {
      "symbol": "Palladium",
      "name": "Palladium"
    },
    {
      "symbol": "PerformanceEnhancers",
      "name": "Performance Enhancers"
    },
    {
      "symbol": "PericlaseDunite",
      "name": "Periclase Dunite"
    },
    {
      "symbol": "PersonalEffects",
      "name": "Personal Effects"
    },
    {
      "symbol": "PersonalWeapons",
      "name": "Personal Weapons"
    },
    {
      "symbol": "Pesticides",
      "name": "Pesticides"
    },
    {
      "symbol": "Platinum",
      "name": "Platinum"
    },
    {
      "symbol": "S_TissueSample_Cells",
      "name": "Pod Core Tissue"
    },
    {
      "symbol": "S_TissueSample_Surface",
      "name": "Pod Dead Tissue"
    },
    {
      "symbol": "S6_TissueSample_Mesoglea",
      "name": "Pod Mesoglea"
    },
    {
      "symbol": "S6_TissueSample_Cells",
      "name": "Pod Outer Tissue"
    },
    {
      "symbol": "S6_TissueSample_Coenosarc",
      "name": "Pod Shell Tissue"
    },
    {
      "symbol": "S_TissueSample_Core",
      "name": "Pod Surface Tissue"
    },
    {
      "symbol": "S9_TissueSample_Shell",
      "name": "Pod Tissue"
    },
    {
      "symbol": "PoliticalPrisoner",
      "name": "Political Prisoners"
    },
    {
      "symbol": "Polymers",
      "name": "Polymers"
    },
    {
      "symbol": "PowerConverter",
      "name": "Power Converter"
    },
    {
      "symbol": "PowerGenerators",
      "name": "Power Generators"
    },
    {
      "symbol": "PowerTransferConduits",
      "name": "Power Transfer Bus"
    },
    {
      "symbol": "Praseodymium",
      "name": "Praseodymium"
    },
    {
      "symbol": "PreciousGems",
      "name": "Precious Gems"
    },
    {
      "symbol": "ProgenitorCells",
      "name": "Progenitor Cells"
    },
    {
      "symbol": "ProhibitedResearchMaterials",
      "name": "Prohibited Research Materials"
    },
    {
      "symbol": "UnknownSack",
      "name": "Protective Membrane Scrap"
    },
    {
      "symbol": "USSCargoPrototypeTech",
      "name": "Prototype Tech"
    },
    {
      "symbol": "Pyrophyllite",
      "name": "Pyrophyllite"
    },
    {
      "symbol": "QuartzPyroxenite",
      "name": "Quartz Pyroxenite"
    },
    {
      "symbol": "RadiationBaffle",
      "name": "Radiation Baffle"
    },
    {
      "symbol": "USSCargoRareArtwork",
      "name": "Rare Artwork"
    },
    {
      "symbol": "ReactiveArmour",
      "name": "Reactive Armour"
    },
    {
      "symbol": "USSCargoRebelTransmissions",
      "name": "Rebel Transmissions"
    },
    {
      "symbol": "ReinforcedMountingPlate",
      "name": "Reinforced Mounting Plate"
    },
    {
      "symbol": "ResonatingSeparators",
      "name": "Resonating Separators"
    },
    {
      "symbol": "Rhodplumsite",
      "name": "Rhodplumsite"
    },
    {
      "symbol": "Robotics",
      "name": "Robotics"
    },
    {
      "symbol": "RockforthFertiliser",
      "name": "Rockforth Fertiliser"
    },
    {
      "symbol": "Ruby",
      "name": "Ruby"
    },
    {
      "symbol": "Rutile",
      "name": "Rutile"
    },
    {
      "symbol": "Samarium",
      "name": "Samarium"
    },
    {
      "symbol": "SAP8CoreContainer",
      "name": "SAP 8 Core Container"
    },
    {
      "symbol": "Sapphire",
      "name": "Sapphire"
    },
    {
      "symbol": "ScientificResearch",
      "name": "Scientific Research"
    },
    {
      "symbol": "ScientificSamples",
      "name": "Scientific Samples"
    },
    {
      "symbol": "Scrap",
      "name": "Scrap"
    },
    {
      "symbol": "UnknownRefinedMineral",
      "name": "Semi-Refined Spire Mineral"
    },
    {
      "symbol": "Semiconductors",
      "name": "Semiconductors"
    },
    {
      "symbol": "Serendibite",
      "name": "Serendibite"
    },
    {
      "symbol": "Silver",
      "name": "Silver"
    },
    {
      "symbol": "SkimerComponents",
      "name": "Skimmer Components"
    },
    {
      "symbol": "Slaves",
      "name": "Slaves"
    },
    {
      "symbol": "SmallExplorationDataCash",
      "name": "Small Survey Data Cache"
    },
    {
      "symbol": "SpacePioneerRelics",
      "name": "Space Pioneer Relics"
    },
    {
      "symbol": "Steel",
      "name": "Steel"
    },
    {
      "symbol": "StructuralRegulators",
      "name": "Structural Regulators"
    },
    {
      "symbol": "Superconductors",
      "name": "Superconductors"
    },
    {
      "symbol": "SurfaceStabilisers",
      "name": "Surface Stabilisers"
    },
    {
      "symbol": "SurvivalEquipment",
      "name": "Survival Equipment"
    },
    {
      "symbol": "SyntheticFabrics",
      "name": "Synthetic Fabrics"
    },
    {
      "symbol": "SyntheticMeat",
      "name": "Synthetic Meat"
    },
    {
      "symbol": "SyntheticReagents",
      "name": "Synthetic Reagents"
    },
    {
      "symbol": "Taaffeite",
      "name": "Taaffeite"
    },
    {
      "symbol": "TacticalData",
      "name": "Tactical Data"
    },
    {
      "symbol": "Tantalum",
      "name": "Tantalum"
    },
    {
      "symbol": "Tea",
      "name": "Tea"
    },
    {
      "symbol": "USSCargoTechnicalBlueprints",
      "name": "Technical Blueprints"
    },
    {
      "symbol": "TelemetrySuite",
      "name": "Telemetry Suite"
    },
    {
      "symbol": "Thallium",
      "name": "Thallium"
    },
    {
      "symbol": "ThargoidTissueSampleType2",
      "name": "Thargoid Basilisk Tissue Sample"
    },
    {
      "symbol": "UnknownBiologicalMatter",
      "name": "Thargoid Biological Matter"
    },
    {
      "symbol": "ThargoidTissueSampleType1",
      "name": "Thargoid Cyclops Tissue Sample"
    },
    {
      "symbol": "ThargoidTissueSampleType6",
      "name": "Thargoid Glaive Tissue Sample"
    },
    {
      "symbol": "ThargoidHeart",
      "name": "Thargoid Heart"
    },
    {
      "symbol": "ThargoidTissueSampleType4",
      "name": "Thargoid Hydra Tissue Sample"
    },
    {
      "symbol": "UnknownArtifact3",
      "name": "Thargoid Link"
    },
    {
      "symbol": "ThargoidTissueSampleType3",
      "name": "Thargoid Medusa Tissue Sample"
    },
    {
      "symbol": "ThargoidTissueSampleType5",
      "name": "Thargoid Orthrus Tissue Sample"
    },
    {
      "symbol": "UnknownArtifact2",
      "name": "Thargoid Probe"
    },
    {
      "symbol": "UnknownResin",
      "name": "Thargoid Resin"
    },
    {
      "symbol": "ThargoidScoutTissueSample",
      "name": "Thargoid Scout Tissue Sample"
    },
    {
      "symbol": "ThargoidTissueSampleType7",
      "name": "Thargoid Scythe Tissue Sample"
    },
    {
      "symbol": "UnknownArtifact",
      "name": "Thargoid Sensor"
    },
    {
      "symbol": "UnknownTechnologySamples",
      "name": "Thargoid Technology Samples"
    },
    {
      "symbol": "ThermalCoolingUnits",
      "name": "Thermal Cooling Units"
    },
    {
      "symbol": "Thorium",
      "name": "Thorium"
    },
    {
      "symbol": "Thortveitite",
      "name": "Thortveitite"
    },
    {
      "symbol": "TimeCapsule",
      "name": "Time Capsule"
    },
    {
      "symbol": "ThargoidTissueSampleType9a",
      "name": "Titan Deep Tissue Sample"
    },
    {
      "symbol": "ThargoidTitanDriveComponent",
      "name": "Titan Drive Component"
    },
    {
      "symbol": "ThargoidTissueSampleType10a",
      "name": "Titan Maw Deep Tissue Sample"
    },
    {
      "symbol": "ThargoidTissueSampleType10c",
      "name": "Titan Maw Partial Tissue Sample"
    },
    {
      "symbol": "ThargoidTissueSampleType10b",
      "name": "Titan Maw Tissue Sample"
    },
    {
      "symbol": "ThargoidTissueSampleType9c",
      "name": "Titan Partial Tissue Sample"
    },
    {
      "symbol": "ThargoidTissueSampleType9b",
      "name": "Titan Tissue Sample"
    },
    {
      "symbol": "Titanium",
      "name": "Titanium"
    },
    {
      "symbol": "Tobacco",
      "name": "Tobacco"
    },
    {
      "symbol": "ToxicWaste",
      "name": "Toxic Waste"
    },
    {
      "symbol": "USSCargoTradeData",
      "name": "Trade Data"
    },
    {
      "symbol": "TrinketsOfFortune",
      "name": "Trinkets of Hidden Fortune"
    },
    {
      "symbol": "Tritium",
      "name": "Tritium"
    },
    {
      "symbol": "AncientRelicTG",
      "name": "Unclassified Relic"
    },
    {
      "symbol": "UnocuppiedEscapePod",
      "name": "Unoccupied Escape Pod"
    },
    {
      "symbol": "UnstableDataCore",
      "name": "Unstable Data Core"
    },
    {
      "symbol": "Uraninite",
      "name": "Uraninite"
    },
    {
      "symbol": "Uranium",
      "name": "Uranium"
    },
    {
      "symbol": "Opal",
      "name": "Void Opal"
    },
    {
      "symbol": "Water",
      "name": "Water"
    },
    {
      "symbol": "WaterPurifiers",
      "name": "Water Purifiers"
    },
    {
      "symbol": "Wine",
      "name": "Wine"
    },
    {
      "symbol": "WreckageComponents",
      "name": "Wreckage Components"
    },
    {
      "symbol": "ThargoidPod",
      "name": "Xenobiological Prison Pod"
    }
  ]
}
